"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettyTime = void 0;
var Symbols;
(function (Symbols) {
    Symbols["days"] = "d";
    Symbols["hours"] = "h";
    Symbols["minutes"] = "m";
    Symbols["seconds"] = "s";
    Symbols["milliseconds"] = "ms";
    Symbols["microseconds"] = "\u00B5s";
    Symbols["nanoseconds"] = "ns";
})(Symbols || (Symbols = {}));
exports.prettyTime = (value) => {
    const fragments = [];
    const types = {
        days: Math.floor(value / 86400000),
        hours: Math.floor(value / 3600000) % 24,
        minutes: Math.floor(value / 60000) % 60,
        seconds: Math.floor(value / 1000) % 60,
        milliseconds: Math.floor(value) % 1000,
        microseconds: Math.floor(value * 1000) % 1000,
        nanoseconds: Math.floor(value * 1e6) % 1000,
    };
    for (const type of ["days", "hours", "minutes", "seconds", "milliseconds", "microseconds", "nanoseconds"]) {
        const value = types[type];
        if (value && value > 0) {
            fragments.push(`${value}${Symbols[type]}`);
        }
    }
    return fragments.join(" ");
};
//# sourceMappingURL=pretty-time.js.map